import {HISTORY_PUSHED} from '@core/scripts/components/history-events';
import {observeDyConsent} from '@dynamic-yield/scripts/components/dynamic-yield/dy-consent';
import {
    initDyEventSender,
    sendDyEvent,
} from '@dynamic-yield/scripts/components/dynamic-yield/dy-event-sender';
import type {
    DyEvent,
    DyRecommendationContext,
} from '@dynamic-yield/scripts/components/dynamic-yield/dy-event-types';
import {observeDyCartEvents} from '@dynamic-yield/scripts/components/dynamic-yield/dy-cart-events';

const DY_CATEGORY_PAGE_TYPE = 'CATEGORY';

declare global {
    interface Window {
        __BONPRIX_DY_CONFIG__?: {
            hasConsent?: boolean;
            vendorId?: string;
            cookieDomain?: string;
            consentEventName?: string;
            currency?: string;
            pendingEvents?: DyEvent[];
        };
    }
}

const config = window.__BONPRIX_DY_CONFIG__ ?? {};

const renderedContext = window.DY?.recommendationContext;
const dyLng = renderedContext?.lng ?? '';
let currentCategoryPath =
    renderedContext?.type === DY_CATEGORY_PAGE_TYPE ? renderedContext.data ?? [] : [];

let contextUrl = window.location.href;
let pendingContext: DyRecommendationContext | undefined;

window.setDyCategoryPath = setDyCategoryPath;
window.sendDyEvent = sendDyEvent;

initDyEventSender(config.hasConsent === true);

(config.pendingEvents ?? []).forEach(sendDyEvent);

observeDyCartEvents({currency: config.currency});

observeDyConsent({
    vendorId: config.vendorId,
    eventName: config.consentEventName ?? 'consent::change',
    hasConsent: config.hasConsent === true,
    cookieDomain: config.cookieDomain,
});

document.addEventListener(HISTORY_PUSHED, writePendingContext);

function getDy(): NonNullable<Window['DY']> {
    return (window.DY = window.DY ?? {});
}

function setDyCategoryPath(categoryPath?: string[]): void {
    const path = (categoryPath ?? [])
        .filter((value): value is string => typeof value === 'string')
        .map((value) => value.toLowerCase());
    if (path.length === 0 || isCurrentCategoryPath(path)) {
        return;
    }

    currentCategoryPath = path;

    const recommendationContext = {type: DY_CATEGORY_PAGE_TYPE, lng: dyLng, data: path};

    if (window.location.href !== contextUrl) {
        writeContext(recommendationContext);
        return;
    }

    pendingContext = recommendationContext;
}

function writePendingContext(): void {
    if (pendingContext === undefined) {
        return;
    }

    writeContext(pendingContext);
}

function writeContext(recommendationContext: DyRecommendationContext): void {
    pendingContext = undefined;
    contextUrl = window.location.href;

    getDy().recommendationContext = recommendationContext;
}

function isCurrentCategoryPath(path: string[]): boolean {
    return (
        currentCategoryPath.length === path.length &&
        currentCategoryPath.every((value, index) => value === path[index])
    );
}
